// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1abT_","largestCol":"styles_largestCol__3OHUU","smallestCol":"styles_smallestCol__1Wjam"};